/**
 * Created by mac on 2/25/20
 */

const Hand = function (game, options) {
    cleverapps.EventEmitter.call(this);

    this.game = game;
    this.difficulty = options.difficulty || 3;
    this.extra = new ExtraHand(game, this);

    this.nullDraws = 0;

    if (options.stack) {
        this.loadSave(options.stack);
    } else {
        this.stack = [];

        for (let i = 0; i < options.num; i++) {
            this.push(TileFactory.Create({}, { noMarks: true }));
        }
    }

    this.customCards = options.cards ? cleverapps.clone(options.cards) : [];
    this.extra.update();

    this.getView = function () {};
};

Hand.prototype = Object.create(cleverapps.EventEmitter.prototype);
Hand.prototype.constructor = Hand;

Hand.prototype.getCardPosition = function (card) {
    const position = {};

    const view = this.getView();
    if (!view) {
        return position;
    }

    const index = this.stack.indexOf(card);
    if (index === -1) {
        return position;
    }

    position.parent = view;
    position.point = view.calcPosition(index);
    return position;
};

Hand.prototype.loadSave = function (data) {
    this.stack = data.map((item) => {
        const card = TileFactory.Create(item, { noMark: true });
        card.setOwner(this);
        card.registerAnimationTime(Card.PLAY_TIMEOUT);
        return card;
    });
};

Hand.prototype.getInfo = function () {
    return {
        difficulty: this.difficulty,
        stack: this.stack.map((card) => card.toJSON())
    };
};

Hand.prototype.cardClicked = function () {
    if (!this.isEmpty()) {
        if (!this.top().inAnimation()) {
            Game.currentGame.shiftCard();
            return true;
        }
    }
    return false;
};

Hand.prototype.isEmpty = function () {
    return this.stack.length === 0;
};

Hand.prototype.addExtra = function (count, options) {
    let i;
    this.game.counter.inc();

    let cards = [];

    const suitableCard = new Card();
    this.setSuitableValue(Game.currentGame.table, suitableCard);

    for (i = 0; i < count - 1; i++) {
        cards.push(new Card());
    }

    const bonus = options.bonus || 0;
    for (i = 0; i < bonus; i++) {
        cards.push(new Wildcard());
    }

    cards = PseudoRandom.GET().shuffle(cards);

    const suitableCardIndex = Math.random() < 0.5 ? cards.length : cards.length - 1;
    cards.splice(suitableCardIndex, 0, suitableCard);

    for (i = 0; i < cards.length; i++) {
        this.push(cards[i]);
    }

    this.showUp(() => {
        this.game.counter.dec();
    });
};

Hand.prototype.push = function (card, options) {
    options = options || {};

    if (card === undefined) {
        card = new Card();
    }

    let index = options.insertIndex !== undefined ? options.insertIndex : this.stack.length;
    if (card instanceof Wildcard && Hand.JOKER_POSITION_IN_HAND !== undefined) {
        index = this.stack.length - Hand.JOKER_POSITION_IN_HAND;
    }
    this.stack.splice(index, 0, card);

    card.setOwner(this);
    card.registerAnimationTime(Card.PLAY_TIMEOUT);
    this.trigger("insert", card, {
        index,
        fromTable: options.fromTable,
        leftward: options.insertIndex === 0
    });

    this.game.counter.trigger();

    this.extra.update();
};

Hand.prototype.moveExist = function (table, proposedShiftCard) {
    if (!proposedShiftCard) {
        return false;
    }

    for (let i = 0; i < table.cards.length; i++) {
        const card = table.cards[i];
        if (card.canPlay(proposedShiftCard)) {
            return true;
        }
    }

    return false;
};

Hand.prototype.setSuitableValue = function (table, card) {
    let n = 0;
    while (n < 1000) {
        if (this.moveExist(table, card)) {
            return true;
        }
        n++;
        card.setRandomValue();
    }
    return false;
};

Hand.prototype.pop = function () {
    const card = this.stack.pop();
    this.trigger("pop");
    return card;
};

Hand.prototype.setCards = function (handValues) {
    handValues = handValues.reverse();

    const cards = [];
    for (let index = 0; index < handValues.length; index++) {
        cards.push(this.stack.pop());
    }

    for (let index = 0; index < cards.length; index++) {
        cards[index].setRank(handValues[index].charAt(0));
        if (handValues[index].charAt(1)) {
            cards[index].setSuit(handValues[index].charAt(1));
        }
        this.stack.push(cards[index]);
    }

    Game.currentGame.shiftCard({
        showUp: true
    });
};

Hand.prototype.shift = function (table) {
    const card = this.pop();
    let updated = false;

    const update = function () {
        if (cleverapps.tutorial.isActive()) {
            return;
        }

        if (this.customCards.length > 0) {
            const value = this.customCards.shift();

            card.setSuit(value.charAt(1));
            card.setRank(value.charAt(0));
            updated = true;
        } else if (!updated) {
            let currentCard = Game.currentGame.open.getCurrentCard();
            while (currentCard && !(currentCard instanceof Wildcard) && card.getRank() === currentCard.getRank()) {
                updated = true;
                card.setRandomValue();
                currentCard = Game.currentGame.open.getCurrentCard();
            }
        }
        if (this.nullDraws > 0 && this.nullDraws >= this.difficulty - 1
            && PseudoRandom.GET().nextDouble() > 0.5 - (this.nullDraws - this.difficulty + 1) * 0.15) {
            updated = this.setSuitableValue(table, card);
        }
    }.bind(this);

    if (!card.wasShown) {
        update();
    }

    if (this.moveExist(table, card)) {
        this.nullDraws = 0;
    } else {
        this.nullDraws++;
    }

    card.open();
    card.trigger("changeValue");

    this.extra.update();

    return card;
};

Hand.prototype.top = function () {
    if (this.stack.length === 0) {
        return undefined;
    }
    return this.stack[this.stack.length - 1];
};

Hand.prototype.showUp = function (f, silent) {
    if (!this.stack.length) {
        f();
        return;
    }

    f = cleverapps.wait(this.stack.length, f);

    this.trigger("show");
    this.stack.forEach((card, index) => {
        card.hide();
        const delay = 0.1 * index;
        card.registerAnimationTime(delay + Card.SHOW_UP_TIMEOUT);
        card.trigger("handShowUp", f, delay, silent);
    });
};

Hand.prototype.showExtraTutorialStep = function () {
    return this.extra.showTutorialStep();
};

Hand.prototype.clear = function () {
    this.stack.forEach((card) => {
        card.clear();
    });
    this.stack = [];
};

Hand.prototype.animateBonus = function (f) {
    let i;
    for (i = 0; i < this.stack.length; i++) {
        if (this.stack[i].inAnimation()) {
            cleverapps.timeouts.setTimeout(() => {
                this.animateBonus(f);
            }, 100);
            return;
        }
    }

    const addReward = function () {
        this.game.addHardReward(RewardsConfig.OneLeftCardReward, true);
    }.bind(this);

    const actions = [];
    const duration = Card.ANIMATE_LEFT_DURATION;

    let needWaitFinish = false;

    for (i = 0; i < this.stack.length; i++) {
        const card = this.stack[this.stack.length - 1 - i];

        actions.push(((card, order, f) => {
            if (Game.currentGame.skipBonusAnimations) {
                addReward(order);
                f();
                return;
            }

            needWaitFinish = true;

            card.trigger("animateLeft", duration, addReward.bind(null, order));

            cleverapps.timeouts.setTimeout(f, duration * 1000 / 6);
        }).bind(this, card, i));
    }

    actions.push((f) => {
        cleverapps.timeouts.setTimeout(f, needWaitFinish ? duration * 1000 : 0);
    });

    cleverapps.focusManager.hideControlsWhileFocused("comboBar");

    cleverapps.focusManager.compound(f, actions);
};

Hand.prototype.hideExtra = function () {
    return this.extra.hide();
};

Hand.JOKER_POSITION_IN_HAND = undefined;